export default "__VITE_ASSET__CtGhsHis__"